import React, {useState, useEffect} from "react";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import ApiService from "../api";
import {toast} from "react-toastify";
import moment from "moment";

const MemberCard = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [paymentId, setPaymentId] = useState(null);
    const [card, setCard] = useState();


    let user = props.Card.CurrentSubscription;
    const stripe = useStripe();
    const elements = useElements();

    useEffect(() => {
        ApiService.fetchCardNo().then((data) => {
            setCard(data);
        });
    }, [paymentId]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const card = elements.getElement(CardElement);
        // console.log(card, "Card payment method");

        // add these lines
        const {paymentMethod, error} = await stripe.createPaymentMethod({
            type: "card",
            card: card,
        });
        if (error) {
            console.log(error);
        } else {
            ApiService.changeStripePaymentMethod({payment_method_id: paymentMethod.id})
                .then((response) => {
                    // console.log(response.data);
                    setShowModal(!showModal);
                    setPaymentId(paymentMethod.id);
                    toast.success("Payment Method changed successfully");
                })
                .catch((error) => {
                    toast.error("Something is wrong!")
                    console.log(error);
                });
        }
    };

    return (
        <div>
            {showModal ? (
                <div className="modalafafaf billing_payment_modal">
                    <div className="modal__container">
                        <button
                            className="btn-close"
                            onClick={() => setShowModal(!showModal)}
                        >
                            &times;
                        </button>
                        <div className="">
                            <h2 className=" text-jost-sb-22"> Payment Method: </h2>
                        </div>
                        <div>
                            <CardElement
                                className="payment__input"
                                type="text"
                                placeholder=""
                                name=""
                                required
                                onChange={(event) => {
                                    if (event.error) {
                                        setError(event.error.message);
                                    } else {
                                        setError(null);
                                    }
                                }}
                                options={{
                                    style: {
                                        base: {
                                            ':focus': {
                                                color: "white",
                                            },
                                        },
                                        complete: {
                                            color: "white"
                                        }
                                    },
                                    hidePostalCode: true

                                }}
                                style={{width: "20rem !important"}}
                            />
                        </div>
                        <button className="res-btn-primary btn-mod" onClick={handleSubmit}>
                            Change
                        </button>

                    </div>
                </div>
            ) : null}
            {user != undefined ? (
                <div>
                    <div key={user.id} className="member__card">
                        <h2 className="text-jost-sb-24">Your clubs membership details:</h2>
                        <div className="member__card-detail">
                            <h2 className=" text-jost-sb-22">Account Opened:</h2>
                            <span>{moment(user.start_date).format('DD/MM/YY')}</span>
                        </div>
                        <div className="member__card-detail">
                            {user.subscription_mapping.status.value == "active" ? (
                                <h2 className=" text-jost-sb-22">Account Expiry:</h2>
                            ) : (
                                <h2 style={{color: "red"}} className=" text-jost-sb-22">
                                    Account Closed Date:
                                </h2>
                            )}
                            <span>{moment(user.annual_billing_end_date).format('DD/MM/YY')}</span>
                        </div>

                        <div className="member__card-detail">
                            <h2 className=" text-jost-sb-22">Payment Frequency: </h2>
                            <span>
                                {user.subscription_mapping.subscription.payment_frequency}
                            </span>
                        </div>

                        <div className="member__card-detail">
                            <h2 className=" text-jost-sb-22">Payment Method: </h2>
                            <div className="member__card-detail-method">
                                <span>
                                  <a>
                                  {card ? card.card_number : ""}
                                      {/* {paymentId ? paymentId: user.stripe_transaction_id} */}
                                  </a>
                                </span>
                                <button
                                    className="text-ops-rg-16-lg "
                                    style={{backgroundColor: "white"}}
                                    onClick={() => setShowModal(!showModal)}
                                >
                                    Change
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="member__card">
                    <h2 className="text-jost-sb-24">Your clubs membership details:</h2>
                    <div className="member__card-detail">
                        <h2 className=" text-jost-sb-22">Account Opened:</h2>
                        <span></span>
                    </div>
                    <div className="member__card-detail">
                        <h2 className=" text-jost-sb-22">Account Expiry:</h2>
                        <span></span>
                    </div>
                    <div className="member__card-detail">
                        <h2 className=" text-jost-sb-22">Payment Frequency: </h2>
                        <span></span>
                    </div>
                    <div className="member__card-detail">
                        <h2 className=" text-jost-sb-22">Payment Method: </h2>
                        <div className="member__card-detail-method">
                            <span>
                                {" "}
                            <a></a>
                            </span>
                            <span className="text-ops-rg-16-lg ">Change</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default MemberCard;
